<template>
  <div>
    <div
      :id="`iframeWrapGuide`"
      style="width:100%;height:100%;"
    ></div>
  </div>
</template>
<script>
import ErrorPage from '@/components/ErrorPage'
import axios from 'axios'
export default {
  name: 'tabIframe',
  props: {
    menu: {
      type: Object,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isFirst: true,
      oldMenu: null,
      iframeSrc: '',
    }
  },
  components: { ErrorPage },
  mounted () {
    this.initIframe()
  },
  methods: {
    initIframe () {
        let iframeWrap = document.getElementById(`iframeWrapGuide`)
        let newIframe = document.createElement('iframe')
        newIframe.style.width = '100%'
        newIframe.style.height = '100%'
        newIframe.setAttribute('id', `iframeWrapGuideChild`)
        newIframe.setAttribute('name', `${this.menu.menuId}`)
        newIframe.setAttribute('src', this.menu.url)
        newIframe.setAttribute('frameborder', 0)
        iframeWrap.appendChild(newIframe)
        newIframe.onload = () => {
          let frameDoc = newIframe.contentDocument || newIframe.contentWindow.document
          frameDoc.onkeydown = e => {
            // this.forbidBackSpace(e)
          }
        }
      }
  },
  watch: {
    menu: {
      handler () {
        let iframeWrap = document.getElementById(`iframeWrapGuide`)
        let iframe = document.getElementById(`iframeWrapGuideChild`)
        let _iframe = iframe.contentWindow
        if (iframe) {
          iframe.src = 'about:blank'
          try {
            _iframe.document.write('')
            _iframe.document.clear()
          } catch (e) {
            console.log(e)
          }
          iframeWrap.removeChild(iframe)
          let newIframe = document.createElement('iframe')
          newIframe.style.width = '100%'
          newIframe.style.height = '100%'
          newIframe.setAttribute('id', `iframeWrapGuideChild`)
          newIframe.setAttribute('src', this.menu.url)
          newIframe.setAttribute('frameborder', 0)
          iframeWrap.appendChild(newIframe)
          newIframe.onload = () => {
            let frameDoc = newIframe.contentDocument || newIframe.contentWindow.document
            frameDoc.onkeydown = e => {
              //this.forbidBackSpace(e)
            }
          }
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
.m-iframe-wrap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
